import React, { useContext, useEffect } from 'react';
import { Loader } from '@ferris/react/components/loader';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { shallowEqual, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { AAP_JOIN_CREATION, JOIN_CREATION } from '../PageFlow/PageList';
import LeadCreateErrorAlert from '../ListYourPropertyPage/LeadForm/LeadCreateErrorAlert';
import { JOIN_SOURCES, JoinCtx } from '../../contexts/join';
import { createPageViewEvent } from '../../utils/EventProviders/EgClickstreamUtil';

function JoinCreation({ isAAP }) {
    const {
        createJoin
    } = useContext(JoinCtx);
    const { trigger } = useContext(TrackingContext);

    const getPropsFromState = (state) => {
        const { lead, hydration } = state;
        const { showLeadCreationError } = lead;
        const { hydrationComplete } = hydration;
        return {
            showLeadCreationError,
            hydrationComplete
        };
    };

    const {
        showLeadCreationError,
        hydrationComplete
    } = useSelector(getPropsFromState, shallowEqual);

    const joinCreationTrigger = async () => {
        await createJoin({
            source: isAAP ? JOIN_SOURCES.AAP : JOIN_SOURCES.JOIN,
            pageName: isAAP ? AAP_JOIN_CREATION : JOIN_CREATION
        });
    };

    useEffect(() => {
        if (hydrationComplete) {
            joinCreationTrigger();
        }
    }, [hydrationComplete]);

    useEffect(() => {
        trigger('pageview', createPageViewEvent('joinconfirmation', 'JoinCreation', '1.12.1'));
    }, []);

    return (
        <div className="update-account-wrapper">
            {
                showLeadCreationError ? (
                    <LeadCreateErrorAlert
                        isDismissable={false}
                        isConventionalLodgingFlow
                    />
                ) : (
                    <Loader visible />
                )
            }

        </div>
    );
}

JoinCreation.propTypes = {
    isAAP: PropTypes.bool
};

JoinCreation.defaultProps = {
    isAAP: false
};

JoinCreation.displayName = JOIN_CREATION;
export default JoinCreation;
